import { Field, FieldProps, Form, Formik, FormikActions } from 'formik';
import React from 'react';
import styled from 'styled-components';

import countries from './../countries';
import TextInput from './ui-components/TextInput';

interface IState {
  gdprChecked: boolean;
  email: string;
  firstname: string;
  lastname: string;
  company: string;
  phone: string;
  country: string;
  marketsegment: string;
  mbquote: string;
}

interface IProps {
  formInput: {
    email: string,
    firstname: string,
    lastname: string,
    company: string,
    phone: string,
    country: string,
    marketsegment: string,
    mbquote: string
  };

  onSubmit: (values: {
    email: string,
    firstname: string,
    lastname: string,
    company: string,
    phone: string,
    country: string,
    marketsegment: string,
    mbquote: string,
    gdprmarketingconsent: boolean
  },
    actions: FormikActions<{
      email: string,
      firstname: string,
      lastname: string,
      company: string,
      phone: string,
      country: string,
      marketsegment: string,
      mbquote: string,
      gdprmarketingconsent: boolean
    }>) => void;
  configuratorValue: string;
  error: boolean | null;
}

const Container = styled.div`
  display: inline-block;
  align-content: center;
  align-items: center;
  justify-content: center;
`;

const Button = styled.input`
  background-color: #FF7203;
  margin: 4px;
  width: 244px;
  border: none;
  color: white;
  padding: 12px 88px;
  text-align: center;
  text-decoration: none;
  font-size: 16px;

  :hover {
    cursor: pointer;
  }
`;

const SelectContainer = styled.div`
  margin: 4px;
`;
const SelectTitle = styled.small`
  align-self: left !important;
`;

const Select = styled.select`
  padding: 8px;
  width: 244px;
  :hover {
    cursor: pointer;
  }
`;

const Input = styled.input`
  :hover {
    cursor: pointer;
  }
`;

const GdprContainer = styled.div`
  padding: 4px;
  margin-top: 16px;
  width: 236px;
  :hover {
    cursor: pointer;
  }
`;

const GdprLabel = styled.div`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

const RedTextLabel = styled.small`
  margin: 4px;
  text-align: center;
  color: #FF0000;
`;

class ContactForm extends React.Component<IProps, IState> {

  state = {
    gdprChecked: false,
    email: this.props.formInput.email,
    firstname: this.props.formInput.firstname,
    lastname: this.props.formInput.lastname,
    company: this.props.formInput.company,
    phone: this.props.formInput.phone,
    country: this.props.formInput.country,
    marketsegment: this.props.formInput.marketsegment,
    mbquote: this.props.formInput.mbquote,
  };

  gdprClicked = (gdprChecked: boolean) => {
    this.setState({
      gdprChecked
    });
  }

  render() {
    const {
      onSubmit,
      configuratorValue,
      error
    } = this.props;

    const {
      email,
      firstname,
      lastname,
      company,
      phone,
      country,
      marketsegment,
    } = this.state;

    return (
      <Container>
        <Formik
          initialValues={{
            email,
            firstname,
            lastname,
            company,
            phone,
            country,
            marketsegment,
            mbquote: 'Yes',
            gdprmarketingconsent: false,
            configurationdata: configuratorValue
          }}
          onSubmit={onSubmit}
          render={() => (
            <Form>
              <Field
                type="text"
                name="email"
                render={({ field, form }: FieldProps) => TextInput({
                  label: 'E-mail',
                  mandatory: true,
                  onChange: (value: string) => { form.setFieldValue(field.name, value); },
                  field
                })}
              />
              <Field
                type="text"
                name="firstname"
                render={({ field, form }: FieldProps) => TextInput({
                  label: 'First name',
                  mandatory: true,
                  onChange: (value: string) => { form.setFieldValue(field.name, value); },
                  field
                })}
              />
              <Field
                type="text"
                name="lastname"
                render={({ field, form }: FieldProps) => TextInput({
                  label: 'Last name',
                  mandatory: true,
                  onChange: (value: string) => { form.setFieldValue(field.name, value); },
                  field
                })}
              />
              <Field
                type="text"
                name="company"
                render={({ field, form }: FieldProps) => TextInput({
                  label: 'Company',
                  mandatory: true,
                  onChange: (value: string) => { form.setFieldValue(field.name, value); },
                  field
                })}
              />
              <Field
                type="number"
                name="phone"
                render={({ field, form }: FieldProps) => TextInput({
                  label: 'Phone',
                  mandatory: false,
                  onChange: (value: string) => { form.setFieldValue(field.name, value); },
                  field
                })}
              />
              <Field
                type="select"
                name="country"
                render={({ form }: FieldProps) => (
                  <SelectContainer>
                    <SelectTitle>Country</SelectTitle><RedTextLabel>*</RedTextLabel>
                    <br />
                    <Select
                      defaultValue={this.props.formInput.country}
                      onChange={(e) => form.setFieldValue('country', e.target.value)}
                      name="country"
                    >
                      <option />
                      {countries.map((country) => { return <option key={country}>{country}</option>; })}
                    </Select>
                  </SelectContainer>
                )}
              />
              <Field
                type="select"
                name="marketsegment"
                render={({ form }: FieldProps) => (
                  <SelectContainer>
                    <SelectTitle>Market Segment</SelectTitle>
                    <br />
                    <Select
                      defaultValue={this.props.formInput.marketsegment}
                      onChange={(e) => form.setFieldValue('marketsegment', e.target.value)}
                      name="marketsegment"
                    >
                      <option />
                      <option>Merchant</option>
                      <option>Cruise & Ferry</option>
                      <option>Offshore</option>
                      <option>Navy</option>
                      <option>Special Vessels</option>
                    </Select>
                  </SelectContainer>
                )}
              />
              <Field
                type="select"
                name="mbquote"
                render={() => (
                  <input
                    type="hidden"
                    name="mbquote"
                  />
                )}
              />
              <GdprContainer>
                <Field
                  type="checkbox"
                  name="gdprmarketingconsent"
                  render={({ form }: FieldProps) => (
                    <div>
                      <Input
                        checked={this.state.gdprChecked}
                        type="checkbox"
                        onChange={
                          (e) => {
                            this.gdprClicked(e.target.checked);
                            form.setFieldValue('gdprmarketingconsent', e.target.checked);
                          }}
                      />
                      <GdprLabel
                        onClick={
                          () => {
                            this.gdprClicked(!this.state.gdprChecked);
                            form.setFieldValue('gdprmarketingconsent', !this.state.gdprChecked);
                          }}
                      >
                        By checking this box you agree to receive communications for marketing purposes.
                          You can unsubscribe at any time.
                      </GdprLabel>
                    </div>
                  )}
                />
              </GdprContainer>
              <Field
                type="hidden"
                name="configurationdata"
                render={() => (
                  <input
                    type="hidden"
                    name="configurationdata"
                  />
                )}
              />
              {error && <div><RedTextLabel>{error}</RedTextLabel></div>}
              <Button type="submit" value="SUBMIT" />
            </Form>
          )}
        />
      </Container>
    );
  }
}

export default ContactForm;
